import NoticeDetail from "../../../../components/units/Edgecross/Announcement/Notice/Details/NoticeDetail";

export default function NoticeDetailsPage() {
  return <NoticeDetail />;
}
